<script>
  import CellDisplayTypes from "./CellDisplayTypes";

  export let headers;
  export let formatter;
  export let totalTaxableAmount;
  export let totalCapitalGainsTax;
  export let rows;
  export let summaryHeader = "Total Capital Gains:"

  const headerClasses = "font-sans font-normal text-base text-gray-700 first:pl-4 first:md:pl-8 first:justify-start justify-center py-5";
  const cellClasses = "first:pl-4 first:md:pl-8 first:justify-start justify-center font-sans font-normal text-base text-neutral-200 py-5";

  const withVisibility = (classesString, index) => `${index == 1 ? "hidden md:flex" : "flex"} ${classesString}`;

  const formatMoney = number => formatter.format(number);

  const formatPercent = number => parseFloat(number).toFixed(2) + "%";

  const getCellDisplayValue = cell => {
    switch (cell.displayType) {
      case CellDisplayTypes.Money:
        return formatMoney(cell.value);
      case CellDisplayTypes.Percent:
        return formatPercent(cell.value);
      default:
        return cell.value;
    }
  }

</script>

<div class="mt-16">
  <div class="text-center font-sans font-medium text-base mb-2.5">{summaryHeader} {formatMoney(totalTaxableAmount)}</div>
  <div class="text-center font-sans font-medium text-2xl">
    Total Capital Gains Tax You Will Pay:&nbsp;&nbsp;<span class="text-primary-400">{formatMoney(totalCapitalGainsTax)}</span>
  </div>

  <table class="w-full table-auto border border-collapse rounded mt-8 bg-white">
    <thead>
      <tr>
        {#each headers as header, i (i)}
          <th>
            <div class={withVisibility(headerClasses, i)}>
              {header}
            </div>
          </th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each rows as cells}
        <tr>
          {#each cells as cell, i (i)}
            <td class="border-y">
              <div class={withVisibility(cellClasses, i)}>
                {getCellDisplayValue(cell)}
              </div>
            </td>
          {/each}
        </tr>
      {/each}
    <tfoot>
      <tr class="bg-gray-100">
        <td>
          <div class={cellClasses}>
            Total Capital Gains Taxes
          </div>
        </td>
        <td></td>
        <td></td>
        <td>
          <div class={cellClasses}>
            <span class="text-success-300">{formatMoney(totalCapitalGainsTax)}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <div class="flex px-8 pt-6 bg-white">
            <svg
              class="inline-block fill-current shrink-0 w-4 h-4 text-warning-400 mt-1.5 mr-2"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <path d="M11.9968 2C9.8127 2 7.81859 2.80193 6.36712 4.18343C4.9479 5.53424 4.07337 7.41346 4.00107 9.57249L4 9.60466L4.00156 9.63681C4.10232 11.6988 5.16518 13.5124 7.08862 15.395L8.33467 20.2984L8.34759 20.3344C8.52581 20.8305 8.8675 21.2422 9.29749 21.5307C9.74333 21.8298 10.2889 22 10.8655 22H10.868L13.3268 21.9935L13.3637 21.9905C13.9229 21.9453 14.4424 21.7398 14.8565 21.4144C15.2672 21.0917 15.5777 20.6474 15.7102 20.1257L17.1248 15.0418C18.9623 13.3842 20 11.4671 20 9.31167C20 7.28714 19.0982 5.45904 17.6553 4.14102C16.2038 2.81516 14.2009 2 11.9968 2ZM7.63301 5.35349C8.74891 4.29138 10.2864 3.66697 11.9968 3.66697C13.7271 3.66697 15.288 4.30548 16.4153 5.33527C17.5353 6.35817 18.2227 7.76299 18.2227 9.31167C18.2227 10.9641 17.4177 12.5218 15.7264 13.9875L15.5353 14.1531L14.7427 17.0009H9.32376L8.70359 14.5604L8.53063 14.3951C6.67096 12.618 5.86389 11.134 5.7786 9.59232C5.84511 7.84647 6.54982 6.38446 7.63301 5.35349ZM9.74737 18.6679H14.2788L13.9876 19.7141L13.9823 19.7356C13.9435 19.8915 13.8502 20.0305 13.7152 20.1365C13.5863 20.2378 13.4227 20.3065 13.2416 20.3269L10.8644 20.333C10.6632 20.3329 10.4788 20.2737 10.3314 20.1748C10.1978 20.0852 10.0984 19.9658 10.0429 19.8309L9.74737 18.6679Z" />
              <path d="M12.1941 7.52069C11.8373 7.46084 11.4705 7.52641 11.1585 7.70579C10.8465 7.88518 10.6094 8.16679 10.4893 8.50076C10.3489 8.89127 9.9114 9.09647 9.51219 8.9591C9.11298 8.82173 8.9032 8.3938 9.04363 8.00329C9.28383 7.33535 9.75794 6.77212 10.382 6.41336C11.006 6.0546 11.7397 5.92346 12.4531 6.04316C13.1666 6.16286 13.8136 6.52569 14.2798 7.06737C14.7459 7.60894 15.001 8.29436 15 9.00226C14.9997 10.1493 14.1302 10.9069 13.5094 11.3117C13.1756 11.5294 12.8472 11.6895 12.6054 11.7947C12.4833 11.8477 12.3806 11.888 12.3065 11.9156C12.2694 11.9294 12.2394 11.9401 12.2175 11.9477L12.1909 11.9568L12.1824 11.9596L12.1794 11.9606L12.1782 11.961C12.178 11.9611 12.1773 11.9613 11.935 11.2502L12.1773 11.9613C11.7758 12.0922 11.3419 11.88 11.208 11.4873C11.0743 11.0948 11.2909 10.6706 11.6919 10.5394L11.6909 10.5397C11.691 10.5397 11.691 10.5397 11.6919 10.5394L11.7041 10.5352C11.7159 10.5311 11.7352 10.5243 11.761 10.5147C11.8126 10.4954 11.8895 10.4654 11.9829 10.4247C12.1721 10.3425 12.4184 10.2215 12.6593 10.0644C13.1877 9.71981 13.4675 9.35322 13.4675 9.00158L13.4675 9.00046C13.468 8.64643 13.3405 8.30364 13.1074 8.0328C12.8743 7.76196 12.5508 7.58055 12.1941 7.52069Z" />
              <path d="M11 14C11 13.4477 11.4455 13 11.995 13H12.005C12.5545 13 13 13.4477 13 14C13 14.5523 12.5545 15 12.005 15H11.995C11.4455 15 11 14.5523 11 14Z" />
            </svg>
            <p class="font-light text-sm text-neutral-200">Disclaimer: The information returned in response to your query is only intended as a general estimate. It does not include the potential effects of locality tax, net investment income tax, itemized or standard deductions, tax credits, or capital losses that may offset your capital gains. See a qualified tax advisor for details.</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
